import React,{useState} from "react";
import ReactTransitionCollapse from 'react-transition-collapse'
import Card from "../UI/Card";
import MediumHeading from "../UI/MediumHeading";

import mobileShopClient from "../../assets/projects/mobileShopClient.png";
import mobileShopAdmin from "../../assets/projects/mobileShopAdmin.png";
import mobileShopClientV from "../../assets/projectVideos/Mobileshopclient.m4v";
import mobileShopAdminV from "../../assets/projectVideos/Mobileshopadmin.m4v";
import amsV from "../../assets/projectVideos/Amsv2-1.m4v";
import masteryV from "../../assets/projectVideos/mastery.mp4";
import darkNetV from "../../assets/projectVideos/Darknetdemo.m4v";
import ams from "../../assets/projects/ams.png";
import lostTransmission from "../../assets/projects/lostTransmission.jpg";
import lostTransmissionV from "../../assets/projectVideos/Losttransmission.m4v";
import yourPersonalityV from "../../assets/projectVideos/Yourpersonality.m4v";
import yourPersonality from "../../assets/projects/yourPersonality.jpg";
import mastery from "../../assets/projects/mastery.jpg";
import darkNet from "../../assets/projects/darkNet.jpg";
import "../UI/style.css";
import "./style.css";

import ReactPlayer from "react-player/lazy";

const Latestprojects = (props) => {

 /*  const [expand, setExpand] = useState(false) */

  const [projectsArray,setProjectsArray] =useState([
    /*  {
      img: portfolio,
      details: "My portfolio project.Build using React Js,vanilla css",
    }, */ {
      title: "Lost Transmission(Mobile App) - 2021",
      img: lostTransmission,
      video: lostTransmissionV,
      details: `      Final year group research in university conducted to find a solution to notify current radio signal transmission failures at radio outstations and predict the probability of upcoming signal failures using IOT technologies and machine learning. The application was designed to benefit the employees related to radio signal transmission.\n\n      My contribution was predicting probability of signal failures using the influence on radio signal failures by weather elements using machine learning. The model predicts the failure probabilities based on weather forecasts values.`,
      link: true,
      expand: false,
      techStack:["React Native(Expo)", "Flask", "Docker", "esp32(nodeMCU)", "AWS EC2", "Firebase"]
    },
    {
      title: "Online article publishing platform(Web App) - 2022",
      img: mastery,
      video: masteryV,
      details:
        <>      One of my side projects. A web application to publish articles. User can publish, update and delete their articles by creating an account and signing in to the system. Used keycloak for authentication. Used elasticsearch for search functionality. dockerized both backend and frontend and deployed to a kubeadm cluster in OCI. {/* The application is deployed at<a className="primaryColor" href="http://mastery.rashids.live"> http://mastery.rashids.live</a> */}</>,
      link: false,
      expand: false,
      techStack:["Spring Boot","Elasticsearch","Postgres","Keycloak","docker","kubernetes", "OCI","React Js","Redux","Bootstrap"]
    },
    {
      title: "Ecommerce client app(Web App) - 2021",
      img: mobileShopClient,
      video: mobileShopClientV,
      details:
        "      One of my side projects. Client app of an ecommerce system(single seller) with React Js ,Node back-end.  Customer can place orders to different addresses and make the payment. Stripe payment gateway is used to make payments. Fully mobile responsive.",
      link: false,
      expand: false,
      techStack:["Node Js","Express Js","MongoDb","Stripe","React Js","Redux","Bootstrap"]
    },
    {
      title: "Ecommerce seller app(Web App) - 2021",
      img: mobileShopAdmin,
      video: mobileShopAdminV,
      details:
        "      One of my side projects. Admin/Seller app of an ecommerce system with React Js and Node back-end. seller can add/update/delete product brands, products and view orders.",
      link: false,
      expand: false,
      techStack:["Node Js","Express Js","MongoDb","React Js","Redux","Bootstrap"]
    },
    {
      title: "A social media(Web) - 2021",
      img: darkNet,
      video: darkNetV,
      details:
        "      One of my side projects. Users can Create an account and start following other users to read their posts. Users can share posts, like the posts of users they are following, and can maintain their profile. So far I have implemented these functionalities in mobile responsive web app.",
      link: false,
      expand: false,
      techStack:["Asp.Net Core", "EF core", "Ms Sql server","Next Js", "React Native", "Redux", "Bootstrap"]
    },
   
    {
      title: "Your Personality(Android App) - 2020",
      img: yourPersonality,
      video: yourPersonalityV,
      details:
        "      A 3ʳᵈ year group project in university. An android app to let users know suitable career paths for their Myers-Briggs personality type based on the answers for the quiz. \n\n      My contribution was implementing the functionality to obtain personality type from answers.",
      link: false,
      expand: false,
      techStack:["Java","Android Studio","sqLite"]
    },
    {
      title: "Apartment Management System(Web App) - 2020",
      img: ams,
      video: amsV,
      details:
        "      A 2ⁿᵈ year group project in university built for an apartment to manage the operations.\n\n      My contribution was implementing functionalities for managing rent informations and complaints(Residents can send complaints from their account.Admin can respond to the complaints. Further admin can add rent informations of residents and generate reports).",
      link: false,
      expand: false,
      techStack:["Java(JSP, servlets)","MySql","JDBC","JasperReports","BootStrap"]
    },
  ]) 

  const renderProjects = projectsArray.map((project,pIndex) =>  (
      <div
        style={{ borderBottom: "solid 2px" }}
        className="projectImgContainer project_container"
        /* style={{ background: "red" }} */ data-aos="zoom-in-up"
      >
        {/*   <img src={project.img} alt="" /> */}
        <p className=" font-22 bold-600 primaryColor ls-1 text-center mtb-10 scaleIn">
          {project.title}
        </p>
        <br />
        <div className="player-wrapper scaleUp">
          <ReactPlayer
            className="react-player"
            width="100%"
            height="100%"
            url={project.video}
            light={project.img}
            playing
            controls
          />
        </div>
        <br />
        <br />

        <div className='flexRow wrap'>
      {project.techStack.map((tech)=>(<span  className="blog_tag blog_tag-blue" style={{fontSize:"18px"}} >{tech}</span>))}
        </div>
        <br />
        <br />
        <p onClick={()=>{
           let newState = [...projectsArray];
           newState[pIndex].expand = !project.expand;
           setProjectsArray(newState)
          }} className="font-25 bold-600 primaryColor ls-1 text-center mtb-10" style={{cursor:"pointer"}}>
          {project.expand?"See less":"Read more"}
    </p>
       {project.expand &&  <p
          style={{ whiteSpace: "pre-wrap", color: "#333333" }}
          className="font-22 mtb-10 plr-10"
        >
          <ReactTransitionCollapse expanded={project.expand} duration={50}>
          {project.details}
        </ReactTransitionCollapse>
         
        </p>}
        {project.expand && project.link && (
          <p
            style={{ whiteSpace: "pre-wrap", color: "#333333" }}
            className="font-22 mtb-10 plr-10"
          >
              <ReactTransitionCollapse expanded={project.expand} duration={50}>
              {`      The research paper has been published at "International Journal of Computing and Digital Systems" `}
            <span>
              <a
                className="primaryColor"
                href="https://journal.uob.edu.bh/handle/123456789/4586"
              >
                can be found here
              </a>
            </span>
            .
        </ReactTransitionCollapse>
           
          </p>
        )}

        <hr
          style={{
            width: "80%",
            margin: "30px auto",
            border: "3px solid #888",
            borderRadius: "3px",
            background: "#888",
          }}
        />
      </div>
    )
  );

  return (
    <div  
      style={{ marginTop: "50px", marginBottom: "50px" }}
    >
      <Card className="flexCol align-center justify-sb">
        {/*   <SmallHeading text="portfolios" /> */}
        <MediumHeading
          text="Portfolios"
          style={{
            textTransform: "uppercase",
            paddingTop: "30px",
            paddingBottom: "30px",
          }}
        />
        <div className="flexRow justify-se wrap ">{renderProjects}</div>
      </Card>
    </div>
  );
};

export default Latestprojects;
